(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./topicCheckers", "./topicFilters", "./topicGetters"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./topicCheckers"), require("./topicFilters"), require("./topicGetters"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.topicCheckers, global.topicFilters, global.topicGetters);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _topicCheckers, _topicFilters, _topicGetters) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.keys(_topicCheckers).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _topicCheckers[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _topicCheckers[key];
      }
    });
  });
  Object.keys(_topicFilters).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _topicFilters[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _topicFilters[key];
      }
    });
  });
  Object.keys(_topicGetters).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    if (key in _exports && _exports[key] === _topicGetters[key]) return;
    Object.defineProperty(_exports, key, {
      enumerable: true,
      get: function get() {
        return _topicGetters[key];
      }
    });
  });
});